import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { AppDataService } from 'app/services';
import { CustomWindow } from 'app/@types';

declare let window: CustomWindow;

@Injectable()
export class HttpProvider implements HttpInterceptor {
    constructor(
        private appData: AppDataService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const conversationId = window.localStorage.getItem('ConversationId');

        // Clone origin request
        req = req.clone({
            // Add ConversationId header
            setHeaders: {
                ConversationId: conversationId ? conversationId : '',
                Authorization: `Bearer ${this.appData.authData.access_token}`
            }
        });

        return next.handle(req);
    }
}
